module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "wrap-black banner-with-copy"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-push-6 col-sm-6"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Please feel free to contact us with any questions or concerns you might have. We're happy to help you out!\n            Please use this form provided and we will get back to you shortly. If you'd like to learn more about our services check out our features page.\n          ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'features'
      }
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-pull-6 col-sm-6 pic"
  }, [_vm._c('InquiryForm', {
    attrs: {
      "subject": "General Inquiry"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h1', [_vm._v("Contact "), _vm._c('br'), _vm._v("Us")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-813cd6e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/home/ContactUsPage.vue
// module id = 692
// module chunks = 1